import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchPaymentHistory } from "../../../../features/PaymentHistory/paymentHistoryThunks";
import "./PaymentHistory.css";

const PaymentHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { history, loadingHistory } = useSelector(
    (state) => state.paymentHistory
  );

  useEffect(() => {
    dispatch(fetchPaymentHistory({ page: 1, limit: 20 }));
  }, [dispatch]);

  if (loadingHistory) {
    return <div className="ph-loader">Loading your orders...</div>;
  }

  return (
    <div className="ph-container">
      <h2 className="ph-title">My Orders</h2>

      <div className="ph-grid">
        {history.map((p) => (
          <div key={p._id} className="ph-card">
            <div className="ph-card-header">
              <h4>{p.paymentFor.toUpperCase()}</h4>
              <span className={`ph-status ${p.payment_status}`}>
                {p.payment_status}
              </span>
            </div>

            <p className="ph-order-id">
              Order ID: <span>{p.orderId}</span>
            </p>

            <div className="ph-amount-box">
              <div>
                <small>Paid Amount</small>
                <strong>₹{p.paidAmount ?? p.totalAmount}</strong>
              </div>
              <div>
                <small>Payment Mode</small>
                <strong>{p.payment_method}</strong>
              </div>
            </div>

            {/* Pending balance — CAM only */}
            {p.paymentFor === "booklet" && p.pendingAmount > 0 && (
              <div
                style={{
                  background: "#fff3cd",
                  border: "1px solid #ffc107",
                  borderRadius: 6,
                  padding: "6px 10px",
                  marginTop: 8,
                  fontSize: 13,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>Pending Balance</span>
                <strong style={{ color: "#dc3545" }}>₹{p.pendingAmount.toFixed(2)}</strong>
              </div>
            )}

            <button
              className="ph-btn"
              onClick={() =>
                navigate(`/dashboard/payment-details/${p.orderId}`)
              }
            >
              View Details
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentHistory;
